import { render, staticRenderFns } from "./MoleculeCardTitleAndDescription.vue?vue&type=template&id=4b5afa7c&scoped=true"
import script from "./MoleculeCardTitleAndDescription.vue?vue&type=script&setup=true&lang=js"
export * from "./MoleculeCardTitleAndDescription.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5afa7c",
  null
  
)

export default component.exports